import { Inject, Injectable } from '@angular/core';
import { Sgkz020aRequest, CodeConversionMstDto, SGKZ020AService, Sgkz020aRequestDisplayItemIdDto } from 'sg-api';
import { catchError, map, timeout } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { ApiCommonService } from 'cbc-shared-lib';
import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';



/**
 * 画面項目IDに紐づくコード変換マスターのデータを取得する。
 * @export
 * @class CodeConversionMstService
 */
@Injectable({
  providedIn: 'root'
})
export class CodeConversionMstService {

  /**
   * コンストラクタ
   * @memberof CodeConversionMstService
   */
  constructor(private sGKZ020AService: SGKZ020AService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * コード変換マスタ取得
   * @param dispItemIdList 画面項目IDリスト
   * @returns コード変換マスタ（key:画面項目ID）
   * @memberof CodeConversionMstService
   */
  public getCodeConversionMst(dispItemIdList: string[]): Observable<Map<string, Array<CodeConversionMstDto>>> {

    let displayItemIdDtoList = new Array<Sgkz020aRequestDisplayItemIdDto>;
    for (let dispItemId of dispItemIdList) {
      let request: Sgkz020aRequestDisplayItemIdDto = {
        dispItemId: dispItemId
      };

      displayItemIdDtoList.push(request);
    }

    let request: Sgkz020aRequest = {
      dispItemIdList: displayItemIdDtoList
    }

    return this.sGKZ020AService.kz10RSGKZ020APost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            let result = new Map<string, Array<CodeConversionMstDto>>();
            for (let key in response.body.codeConversionMstTbl) {
              result.set(key, response.body.codeConversionMstTbl[key]);
            }

            return result;
          }),

        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'sys', 'SGKZ020A');
          return throwError(err.message);
        })
      );
  }
}
